import { ApiGetRequest, ApiPutRequest } from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Akun Jenis PemBayaran',
    title_bank: 'Akun Jenis Pembayaran',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/conf',
      },
      {
        text: 'AkunJenisBayar',
        href: '/adm/conf/akun-jenis-pembayaran',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_account_payment',
    sortDesc: true,
    fields: [
      {
        key: 'label_payment',
        label: 'Payment',
        sortable: true,
      },

      {
        key: 'code_acc',
        label: 'Kode Akun',
        sortable: true,
      },
      {
        key: 'klasifikasi',
        label: 'Klasifikasi',
        sortable: true,
      },
      {
        key: 'acc_name',
        label: 'Nama Akun',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {
      id_account: '',
      acc_code: '',
      acc_name: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeAkunJenisBayar(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchAkunJenisBayar(context, params = null) {
    let result = await ApiGetRequest(`conf/akun-jenis-bayar`, params);
    return !result.error ? result.data.object : [];
  },

  async getListAkunJenisBayar({ commit, state }) {
    commit('changeAkunJenisBayar', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`conf/akun-jenis-bayar`, params);
    commit('changeAkunJenisBayar', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailAkunJenisBayar({ commit, state }, payload = null) {
    commit('changeAkunJenisBayar', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`conf/akun-jenis-bayar/${payload.id}`);
    commit('changeAkunJenisBayar', {
      loading: false,
      form: {
        ...data.form,
        ...result.data.object,
      },
    });

    return result.error ? false : true;
  },

  async updateAkunJenisBayar({ commit, state, dispatch }, payload = null) {
    commit('changeAkunJenisBayar', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `conf/akun-jenis-bayar/${payload.id}`,
      state.data.form
    );

    commit('changeAkunJenisBayar', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },
};
